import { FieldWrapper } from '@fukuri-admins/ui/common/Form/FieldWrapper';
import { extractErrorMessages } from '@fukuri-admins/ui/common/Form/logics/extractErrorMessages';
import { useController, useFormContext } from 'react-hook-form';
import { CustomFieldForm } from '~/components/common/CustomFieldForm';
import { CustomFieldDefinition } from '~/types/resources/CustomFieldDefinition';

type Props = {
  /** react-hook-form のフィールド名（例: `customFields.{label}`） */
  name: string;
  /** カスタムフィールド定義 */
  field: CustomFieldDefinition;
};

export const CustomFieldFormController: React.FC<Props> = ({ name, field }) => {
  const { control } = useFormContext();

  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ control, name });

  const resolvedValue = (): string | string[] => {
    if (value !== undefined && value !== null) return value;
    return field.input_type === 'multi_choice' ? [] : '';
  };

  return (
    <FieldWrapper
      htmlFor={name}
      labelText={field.label}
      errorMessages={extractErrorMessages(error)}
    >
      <CustomFieldForm field={field} value={resolvedValue()} onChange={onChange} />
    </FieldWrapper>
  );
};
